module.exports = __webpack_public_path__ + "static/media/posture4.432f4ab4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posture4.jpg
// module id = 198
// module chunks = 0